import { pipe } from 'fp-ts/function';
import { SettlementRuleParameters } from '@mews-commander/data-access';
import { DurationService } from '@mews/framework';
import { FormValues } from './components/schema';
import { SettlementRuleFormField, SettlementRuleOffsetType } from './types';

export const prepareSettlementRuleValues = (values: FormValues): SettlementRuleParameters => {
    const { offsetType, name, key, ...rest } = values;

    const durationOffset = DurationService.fromObject(values.offset);

    return {
        ...rest,
        [SettlementRuleFormField.Name]: name || null,
        [SettlementRuleFormField.PaymentPolicyKey]: key || null,
        [SettlementRuleFormField.Offset]:
            offsetType === SettlementRuleOffsetType.Before
                ? pipe(durationOffset, DurationService.negate, DurationService.toString)
                : pipe(durationOffset, DurationService.toString),
    };
};
